import { FocusEvent, Ref, forwardRef, useRef } from 'react';
import './EpInput.scss';
import { EpTextareaProps } from '.';

export const EpTextarea = forwardRef(function EpInput(
  {
    inputId,
    inputName,
    inputValue,
    inputAriaDescribedby,
    inputSize,
    inputMaxLength,
    inputWidth = 300,
    inputIsFullWidth = false,
    inputIsDisabled = false,
    inputWithError = false,
    inputPlaceholder = '',
    customClasses,
    ...props
  }: EpTextareaProps,
  ref: Ref<HTMLTextAreaElement>,
) {
  const epTextareaRef = useRef<HTMLDivElement>(null);
  //TODO: Trocar a classe "ep-input--with-focus" por "focus-ring" quando o bootstrap for atualizado
  const handleInputFocus = ({
    target,
  }: FocusEvent<HTMLTextAreaElement>): void => {
    if (inputWithError || inputIsDisabled) return;
    const inputCurrent = epTextareaRef.current;
    if (!inputCurrent) return;

    inputCurrent.classList.add('ep-input--with-focus');
    target.addEventListener('blur', () => inputCurrent.classList.remove('ep-input--with-focus'),
    );
  };

  return (
    <div
      {...(inputIsFullWidth
        ? { style: { width: '100%' } }
        : { style: { width: `${inputWidth}px` } })}
    >
      <div
        ref={epTextareaRef}
        className={`
          form-control ep-input
          ep-input--${inputSize}
          ${inputIsFullWidth ? 'ep-input--is-full-width' : ''}
          ${inputWithError ? 'ep-input--with-error' : ''}
          ${inputIsDisabled ? 'ep-input--disabled' : ''}
          ${customClasses ? customClasses : ''}
        `}
        {...(!inputIsFullWidth && { style: { width: `${inputWidth}px` } })}
        {...(inputValue !== null &&
          inputValue !== undefined && { value: inputValue })}
      >
        <textarea
          {...props}
          id={inputId}
          ref={ref as Ref<HTMLTextAreaElement>}
          className="ep-input__field"
          rows={
            inputSize === 'sm'
              ? 4
              : inputSize === 'md'
                ? 5
                : inputSize === 'lg'
                  ? 8
                  : 4
          }
          name={inputName}
          {...(inputValue !== null &&
            inputValue !== undefined && { value: inputValue })}
          aria-describedby={inputAriaDescribedby}
          placeholder={inputPlaceholder}
          disabled={inputIsDisabled ? true : false}
          maxLength={inputMaxLength ? inputMaxLength : undefined}
          {...(!inputIsFullWidth && { style: { width: `${inputWidth}px` } })}
          onFocus={handleInputFocus}
        />
      </div>
    </div>
  );
});
